import { ItemWithTranslation } from 'types/swagger';
import { useTypedSelector } from 'lib/centralStore';
import { SportManifestazioneHeaderTitle } from './sportManifestazioneHeaderTitle';
import { SportResultsAndInfoContent } from '../sportResultsAndInfoContent';
import { SportResultsAndInfoTrigger } from '../sportResultsAndInfoTrigger';
import { StatisticType } from 'features/sport/utils/betRadar/statisticTypeEnum';
import { Wrapper } from 'components/wrapper';
import styles from './SportManifestazioneHeader.module.scss';
import { selectIsInfoOpen } from 'features/sport/selectors';

export type SportManifestazioneHeaderProps = ItemWithTranslation<{ gruppo?: string; manifestazione?: string }> & {
  idGruppo: number;
  providerId?: string | number;
  iconSrc?: string;
  noPaddingRight?: boolean;
  idManifestazione: number;
  slugManifestazione?: string;
};

export const SportManifestazioneHeader = ({
  gruppo,
  iconSrc,
  idGruppo,
  providerId,
  gruppoTrKey,
  manifestazione,
  noPaddingRight,
  idManifestazione,
  slugManifestazione,
  manifestazioneTrKey,
}: SportManifestazioneHeaderProps) => {
  const isInfoOpen = useTypedSelector(selectIsInfoOpen);

  return (
    <Wrapper bgColorTransparent noPaddingTop noPaddingBottom noPaddingLeft noPaddingRight={noPaddingRight}>
      <div className={styles.container}>
        <SportManifestazioneHeaderTitle
          gruppo={gruppo}
          gruppoTrKey={gruppoTrKey}
          manifestazione={manifestazione}
          manifestazioneTrKey={manifestazioneTrKey}
          image={
            iconSrc
              ? {
                  src: iconSrc,
                  alt: '',
                  title: '',
                }
              : undefined
          }
          idManifestazione={idManifestazione}
          slugManifestazione={slugManifestazione}
        />

        {providerId && providerId !== '0' && <SportResultsAndInfoTrigger />}
      </div>

      {providerId && providerId !== '0' && isInfoOpen && (
        <SportResultsAndInfoContent isOpen providerID={+providerId} type={StatisticType.Manifestazione} />
      )}
    </Wrapper>
  );
};
